import styled from "styled-components";
import CheckoutForm from "../components/forms/CheckoutForm";
import Navbar from "../components/navbar/Navbar";
import CartBilling from "../components/section/cart/CartBilling";
import CartItem from "../components/section/cart/CartItem";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  margin: 150px 40px;
  display: flex;
  justify-content: space-around;
  position: relative;
  overflow-y: hidden;
`;

const Left = styled.div`
  flex-grow: 1;
  max-width: 800px;
  height: calc(100vh - 150px);
  overflow-y: auto;
`;

const Right = styled.div`
  width: 400px;
  margin-left: 40px;
  position: sticky;
  top: 150px;
`;

const Text = styled.div`
  p {
    letter-spacing: 5%;
    line-height: 15px;
    color: #000000;
    font-size: 12px;
  }
`;

function CheckoutPage() {
  return (
    <Wrapper>
      <Navbar />
      <Container>
        <Left>
          <Text>
            <p>
              Fast Delivery & Easy Returns. DHL 59 SEK, 1-3 days delivery to
              pick up point. PostNord 79 SEK, 1-3 days delivery to pick up
              point. Budbee 99 SEK, Home delivery in 1-3 days. Return fee of 69
              SEK is charged upon return.
            </p>
          </Text>
          <CheckoutForm />
        </Left>
        <Right>
          <CartItem />
          <CartItem />
          <CartItem />
          <CartBilling />
        </Right>
      </Container>
    </Wrapper>
  );
}

export default CheckoutPage;
